import { render } from "./FooterTop.vue?vue&type=template&id=55a65a24&scoped=true"
import script from "./FooterTop.vue?vue&type=script&lang=js"
export * from "./FooterTop.vue?vue&type=script&lang=js"

import "./FooterTop.vue?vue&type=style&index=0&id=55a65a24&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a65a24"]])

export default __exports__